import React, { Component } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Card,
  Drawer,
  Modal,
  Spin,
  Pagination,
  notification,
} from "antd";
import { api, app, config } from "../../app";
import { getInsuranceList, insuraTypeSelectLists } from "./insure_api";
import common from "../review/common";
import utils from "../../utils";
import IUpload from "./IUpload";
import IEditList from "./IEditList";
import { getInsuranceOrgInvoice } from "./insure_org_api";

const { Option } = Select;

class IList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      page: 1,
      data_loading: true,
      upload_visible: false,
      record_visible: false,
      type_loading: true,
      dataList: [],
      typeList: [],
      uploadInfo: null,
      edit_record_id: null,
      filter_review: "0",
      filter_type: "0",
      noticeList: [],
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.setData({
      typeList: await insuraTypeSelectLists(),
      type_loading: false,
    });
    await this.dataSource(1);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 数据列表
   * @param page
   * @returns {Promise<void>}
   */
  dataSource = async (page) => {
    const state = { data_loading: true, dataList: [] };
    if (page) {
      state.page = page;
    } else {
      page = this.state.page;
    }
    await this.setData(state);
    const { filter_review, filter_type } = this.state,
      params = { page, status: filter_review, type: filter_type };
    const { data, total } = await getInsuranceList(params);
    if (page === this.state.page) {
      const noticeList = [...this.state.noticeList];
      for (let i = 0; i < data.length; i++) {
        if (data[i].tip && noticeList.indexOf(data[i].id) === -1) {
          noticeList.push(data[i].id);
          notification.warning({
            message: "温馨提示",
            description: (
              <div>
                <div>保险名称：{data[i].name}</div>
                <div>保险单号：{data[i].cntr_no}</div>
                <div>{data[i].tip}</div>
              </div>
            ),
            duration: null,
          });
        }
      }
      await this.setData({
        total,
        dataList: utils.addArrayKey(data),
        noticeList,
        data_loading: false,
      });
    }
  };

  /**
   * 打开上传
   * @returns {Promise<void>}
   */
  handleOpenUpload = async (info) => {
    const state = { upload_visible: true };
    if (info) {
      state.uploadInfo = info;
    } else {
      state.uploadInfo = null;
    }
    await this.setData(state);
  };

  /**
   * 查看发票
   * @param id
   * @returns {Promise<void>}
   */
  handleSeeInvoice = async (id) => {
    const data = await getInsuranceOrgInvoice(id);
    if (data && data.url) {
      window.open(data.url, "_blank");
    }
  };

  render() {
    let {
      total,
      page,
      data_loading,
      dataList,
      upload_visible,
      uploadInfo,
      record_visible,
      edit_record_id,
      typeList,
      type_loading,
    } = this.state;
    return (
      <div className="insure-list-page">
        <div className="ilp-body">
          <div className="il-title">我的保险</div>
          <Row className="il-filter" type="flex" justify="space-between">
            <Col>
              <label>审核类型：</label>
              <Select
                size="small"
                style={{ width: 160 }}
                placeholder="请选择"
                onChange={(v) => this.setData({ filter_review: v })}
              >
                <Option value="0">全部</Option>
                <Option value="1">未审核</Option>
                <Option value="2">已审核</Option>
              </Select>
              <label style={{ marginLeft: 15 }}>保险产品类型：</label>
              <Select
                size="small"
                style={{ width: 160 }}
                placeholder="请选择"
                onChange={(v) => this.setData({ filter_type: v })}
                notFoundContent={type_loading ? <Spin size="small" /> : null}
              >
                <Option value="0">全部</Option>
                {typeList.map((c) => (
                  <Option key={c.value}>{c.name}</Option>
                ))}
              </Select>
              <Button
                size="small"
                style={{ marginLeft: 15 }}
                type="primary"
                onClick={() => this.dataSource(1)}
              >
                确定
              </Button>
            </Col>
            <Col>
              <Button
                size="small"
                type="primary"
                onClick={() => this.handleOpenUpload()}
              >
                上传保险
              </Button>
            </Col>
          </Row>
          <div className="il-data">
            <Spin spinning={data_loading} tip="正在加载">
              {dataList.length ? (
                dataList.map((order) => {
                  let btns = [];
                  let audit = false;
                  if (
                    order.team_header_audit === 1 ||
                    order.admin_audit === 1
                  ) {
                    audit = true;
                  }
                  if (order.buy_type === "1") {
                    if (order.is_invoice === "1") {
                      btns.push(
                        <Button
                          style={{ marginLeft: 6 }}
                          key="btn1"
                          size="small"
                          onClick={() => this.handleSeeInvoice(order.id)}
                        >
                          查看发票
                        </Button>
                      );
                    }
                    btns.push(
                      <Button
                        size="small"
                        key="btn3"
                        href={app.urlGet(api.DownloadInsurance, {
                          id: order.id,
                          token: app.getToken(),
                          indexno: app.getData("indexno"),
                          account: app.getData("account"),
                        })}
                      >
                        下载保单
                      </Button>
                    );
                    if (order.type === "1") {
                      return (
                        <div className="ld-item" key={order.id}>
                          <Row
                            type="flex"
                            justify="space-between"
                            align="middle"
                          >
                            <div className="di-name">
                              {order.name}{" "}
                              <span className="di-company">
                                【{order.company}】
                              </span>
                            </div>
                          </Row>
                          <Row gutter={10}>
                            <Col span={8}>
                              <div className="di-item">
                                保险类型：{order.type_title}
                              </div>
                              <div className="di-item">
                                保险单号：{order.cntr_no}
                              </div>
                              <div className="di-item">
                                保险有效期：{order.start_date} ~{" "}
                                {order.end_date}
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="di-item">
                                被保人：{order.ipsn_name}
                              </div>
                              <div className="di-item">
                                手机号：{order.mobile || "-"}
                              </div>
                              <div className="di-item">
                                邮箱：{order.email || "-"}
                              </div>
                            </Col>
                            <Col span={8}>
                              <div
                                className="di-btns"
                                style={{ marginTop: 60 }}
                              >
                                {btns}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      );
                    } else if (order.type === "2") {
                      return (
                        <div className="ld-item" key={order.id}>
                          <Row
                            type="flex"
                            justify="space-between"
                            align="middle"
                          >
                            <div className="di-name">
                              {order.name}{" "}
                              <span className="di-company">
                                【{order.company}】
                              </span>
                            </div>
                          </Row>
                          <Row gutter={10}>
                            <Col span={8}>
                              <div className="di-item">
                                保险类型：{order.type_title}
                              </div>
                              <div className="di-item">
                                保险方案：{order.scheme_name}
                              </div>
                              <div className="di-item">
                                保险单号：{order.cntr_no}
                              </div>
                              <div className="di-item">
                                保险有效期：{order.start_date} ~{" "}
                                {order.end_date}
                              </div>
                              <div className="di-item">
                                发票：
                                {order.is_invoice === "1"
                                  ? order.taxpayer_no
                                  : "无"}
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="di-item">
                                姓名/公司名：{order.ipsn_name}
                              </div>
                              <div className="di-item">
                                手机号：{order.mobile}
                              </div>
                              <div className="di-item">邮箱：{order.email}</div>
                              <div className="di-item">
                                是否负责人：
                                {order.is_head === "1" ? "是" : "否"}
                              </div>
                              <div className="di-item">
                                承保人数：{order.num}
                              </div>
                            </Col>
                            <Col span={8}>
                              <div
                                className="di-btns"
                                style={{ marginTop: 120 }}
                              >
                                {btns}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      );
                    }
                  } else {
                    // audit &&
                    btns.push(
                      <Button
                        style={{ marginLeft: 6 }}
                        key="btn2"
                        size="small"
                        type="primary"
                        onClick={() => this.handleOpenUpload(order)}
                      >
                        详情/编辑
                      </Button>
                    );
                    btns.push(
                      <Button
                        style={{ marginLeft: 6 }}
                        key="btn4"
                        size="small"
                        onClick={() =>
                          this.setData({
                            edit_record_id: order.id,
                            record_visible: true,
                          })
                        }
                      >
                        修改记录
                      </Button>
                    );
                    return (
                      <div className="ld-item" key={order.id}>
                        <Row type="flex" justify="space-between" align="middle">
                          <div className="di-name">
                            {order.name}{" "}
                            <span className="di-company">
                              【{order.company}】
                            </span>
                          </div>
                        </Row>
                        <Row gutter={10}>
                          <Col span={8}>
                            <div className="di-item">
                              保险类型：{order.type_title}
                            </div>
                            <div className="di-item">
                              保险单号：{order.cntr_no}
                            </div>
                            <div className="di-item">
                              保险有效期：{order.start_date} ~ {order.end_date}
                            </div>
                            <div className="di-item">
                              <span style={{ verticalAlign: "top" }}>
                                管理员审核：
                              </span>
                              <span style={{ display: "inline-block" }}>
                                {common.tableStatus(
                                  String(order.team_header_audit),
                                  order.team_header_name,
                                  order.team_header_time,
                                  order.detail
                                )}
                              </span>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div className="di-item">
                              投保人：{order.hldr_name}
                            </div>
                            <div className="di-item">
                              手机号：{order.mobile || "-"}
                            </div>
                            {/* <div className="di-item">邮箱：{order.email || '-'}</div> */}
                            {/* <div className="di-item"><span style={{verticalAlign: 'top'}}>省管审核：</span><span
                              style={{display: 'inline-block'}}>{common.tableStatus(String(order.admin_audit), order.admin_name, order.admin_time, order.detail)}</span>
                            </div> */}
                          </Col>
                          <Col span={8}>
                            <div className="di-item">
                              被保人：{order.ipsn_name}
                            </div>
                            <div className="di-item">
                              邮箱：{order.email || "-"}
                            </div>
                            <div className="di-btns" style={{ marginTop: 90 }}>
                              {btns}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    );
                  }
                })
              ) : (
                <div className="null-data">暂无数据</div>
              )}
              <div style={{ textAlign: "right", padding: "20px 0" }}>
                <Pagination
                  current={page}
                  total={total}
                  pageSize={20}
                  showTotal={(t) => `共${t}条.`}
                  size="small"
                  onChange={this.dataSource}
                />
              </div>
            </Spin>
          </div>
        </div>
        <Drawer
          title={uploadInfo ? "修改保险" : "上传保险"}
          placement="right"
          onClose={() => this.setData({ upload_visible: false })}
          visible={upload_visible}
          width={700}
          maskClosable={false}
          getContainer={false}
          destroyOnClose={true}
          bodyStyle={{
            overflowY: "auto",
            height: "calc(100% - 55px)",
            padding: 15,
          }}
        >
          <IUpload
            info={uploadInfo}
            onCancel={async () => {
              await this.setData({ upload_visible: false });
              await this.dataSource(1);
            }}
          />
        </Drawer>
        <Modal
          visible={record_visible}
          title="保险修改记录"
          onCancel={() =>
            this.setData({ record_visible: false, edit_record_id: null })
          }
          footer={null}
          maskClosable={false}
          destroyOnClose={true}
          width="80%"
          centered
        >
          <IEditList id={edit_record_id} />
        </Modal>
      </div>
    );
  }
}

export default IList;



// WEBPACK FOOTER //
// ./src/routes/insure/IList.jsx